import { NameFormErrors, NameFormTouched, NameFormValues } from './types';

export const isKatakana = (text: string): boolean => {
    return /^[\u30A0-\u30FF\u31F0-\u31FF]*$/.test(text);
};

const validateKanaField = (value: string, touched: boolean): string => {
    if (!touched) return '';
    if (!value) return '入力してください';
    if (!isKatakana(value)) return 'カタカナで入力してください';
    return '';
};

const validateRequiredField = (value: string, touched: boolean): string => {
    if (!touched) return '';
    if (!value) return '入力してください';
    return '';
};

export const validateForm = (
    values: NameFormValues,
    touched: NameFormTouched
): NameFormErrors => {
    return {
        lastName: validateRequiredField(values.lastName, touched.lastName),
        firstName: validateRequiredField(values.firstName, touched.firstName),
        lastNameKana: validateKanaField(
            values.lastNameKana,
            touched.lastNameKana
        ),
        firstNameKana: validateKanaField(
            values.firstNameKana,
            touched.firstNameKana
        ),
    };
};

export const checkFormValidity = (values: NameFormValues): boolean => {
    return (
        values.lastName !== '' &&
        values.firstName !== '' &&
        values.lastNameKana !== '' &&
        values.firstNameKana !== '' &&
        isKatakana(values.lastNameKana) &&
        isKatakana(values.firstNameKana)
    );
};
